import React, { useRef, useEffect, useState } from "react";
import "../../Styles/Map.css";
import "../../Styles/ReIntro.css";
import "../../Styles/ReMap.css";
import Legend from "./Legend";
import Chart from "./Chart";
import mapboxgl from 'mapbox-gl';
import { world_religion } from "./WorldReligion";
import Scale1 from '../../Assets/stripe1.jpg';
import Scale2 from '../../Assets/stripe2.jpg';
import Scale3 from '../../Assets/stripe2.jpg';

mapboxgl.accessToken = 'pk.eyJ1IjoiZWRtYW4iLCJhIjoiY2syNWs1ajk3MGM2NjNua3gxYTNhdWpkOSJ9.ngu-SlVjhLdLBPyDFFsIBw';

const Buddhism = () => {
    const mapContainer = useRef(null);
    const map = useRef(null);
    const [lng, setLng] = useState(-70.9);
    const [lat, setLat] = useState(42.35);
    const [zoom, setZoom] = useState(1);
    const [firstReligion, setFirstReligion] = useState("...");
    const [secondReligion, setSecondReligion] = useState("...");
    const [province, setProvince] = useState("...");
    const [country, setCountry] = useState("...");
    const [numerical, setNumerical] = useState(null);
    const [year, setYear] = useState("...");
    const [dataSource, setDataSource] = useState("...");
    const [display, setDisplay] = useState("map");
    const buddhismSubs= ["Tibetan","Theravada","Mahayana"];
    let hoveredStateId = null;

    useEffect(() => {
        if (map.current) return; // initialize map only once
        map.current = new mapboxgl.Map({
            container: mapContainer.current,
            style: 'mapbox://styles/mapbox/light-v10',
            center: [lng, lat],
            zoom: zoom,
            maxZoom: 5
        });
        map.current.addControl(new mapboxgl.NavigationControl());
    }, []);

    useEffect(() => {
        map.current.on('load', () => {
            map.current.addSource('world_religion', {
                'type': 'vector',
                'url': 'mapbox://edman.BRI_Religion_JSON2'
            });
            map.current.addLayer(world_religion, 'state-label');
            map.current.addLayer({
                'id': 'state-fills',
                'type': 'fill',
                'source': 'world_religion',
                'source-layer': 'BRI_Religion_JSON2',
                'layout': {},
                'paint': {'fill-color': 'transparent','fill-outline-color':'black','fill-opacity': ['case',['boolean', ['feature-state', 'click'], false],1,0]}
                }
            );
            map.current.addLayer({
                'id': 'hover-fills',
                'type': 'line',
                'source': 'world_religion',
                'source-layer': 'BRI_Religion_JSON2',
                'layout': {},
                'paint': {'line-width': 1}
                },'state-label'
            );
            map.current.loadImage(Scale1, function (error0, image0) {
                if (error0) throw error0;
                map.current.addImage("S1", image0, {});
                map.current.addLayer({
                    "id": "S1",
                    "type": "fill",
                    "source": "world_religion",
                    'maxzoom': 5,
                    'minzoom': 4,
                    'filter': ["all",['==', 'HighRelig0', 'Buddhism'],['==', 'SecRelig', 'Protestants']],
                    'paint': {'fill-pattern': 'S1','fill-opacity': 0.7,},
                    'source-layer': 'BRI_Religion_JSON2',
                }, 'hover-fills');
            });
            map.current.loadImage(Scale2, function (error0, image0) {
                if (error0) throw error0;
                map.current.addImage("S2", image0, {});
                map.current.addLayer({
                    "id": "S2",
                    "type": "fill",
                    "source": "world_religion",
                    'maxzoom': 4,
                    'minzoom': 3,
                    'filter': ["all",['==', 'HighRelig0', 'Buddhism'],['==', 'SecRelig', 'Protestants']],
                    'paint': {'fill-pattern': 'S2','fill-opacity': 0.7,},
                    'source-layer': 'BRI_Religion_JSON2',
                }, 'hover-fills');
            });
            map.current.loadImage(Scale3, function (error0, image0) {
                if (error0) throw error0;
                map.current.addImage("S3", image0, {});
                map.current.addLayer({
                    "id": "S3",
                    "type": "fill",
                    "source": "world_religion",
                    'maxzoom': 3,
                    'minzoom': 2,
                    'filter': ["all",['==', 'HighRelig0', 'Buddhism'],['==', 'SecRelig', 'Protestants']],
                    'paint': {'fill-pattern': 'S3','fill-opacity': 0.7,},
                    'source-layer': 'BRI_Religion_JSON2',
                }, 'hover-fills');
            });
        });

        map.current.on('mousemove', 'state-fills', (e) => {
            map.current.setFilter("hover-fills", [
                "any",
                ["==", "ProvName", e.features[0].properties.ProvName],
              ]);
            setFirstReligion(e.features[0].properties.HighRelig);
            setSecondReligion(e.features[0].properties.SecRelig);
            setProvince(e.features[0].properties.ProvName);
            setCountry(e.features[0].properties.Country);
            setNumerical(e.features[0].properties.Numerical);
            setYear(e.features[0].properties.Year);
            setDataSource(e.features[0].properties.DataSource);
            
        });
        map.current.on('click', 'hover-fills', (e) => {
            map.current.setFilter("hover-fills", [
                "any",
                ["==", "ProvName", e.features[0].properties.ProvName],
              ]);
            setFirstReligion(e.features[0].properties.HighRelig);
            setSecondReligion(e.features[0].properties.SecRelig);
            setProvince(e.features[0].properties.ProvName);
            setCountry(e.features[0].properties.Country);
            setNumerical(e.features[0].properties.Numerical);
            setYear(e.features[0].properties.Year);
            setDataSource(e.features[0].properties.DataSource);
            
        });
        map.current.on('mouseleave', 'state-fills', () => {
            map.current.setFilter("hover-fills", false);}
        );
        map.current.setRenderWorldCopies(false);
        map.current.flyTo({
          center: [80, 30],
          zoom: 2.5,
        });

        map.current.on('moveend', () => {
            const features = map.current.queryRenderedFeatures({
              layers: ['world_religion']
            });
        
            if (features) {
              renderListings(features);
            }
          });

        map.current.on('load', () => {
          map.current.setFilter("world_religion", [
            "any",
            ["==", "HighRelig", "Buddhists(Tibetan Buddhism)"],
            ["==", "HighRelig", "Buddhists(Theravada)"],
            ["==", "HighRelig", "Buddhists(Mahayana)"],
          ]);
          map.current.setFilter("state-fills", [
            "any",
            ["==", "HighRelig", "Buddhists(Tibetan Buddhism)"],
            ["==", "HighRelig", "Buddhists(Theravada)"],
            ["==", "HighRelig", "Buddhists(Mahayana)"],
          ]);
          map.current.setFilter("hover-fills", false);
              })
    }, []);
    
    //useEffect(() => {
    //    map.current.on('idle', () => {
    //    map.current.setFilter('world_religion', ['==', 'HighRelig', 'East Asian Religiosity'])
    //    })
    //}, []);
   

    function renderListings(features) {
        const empty = document.createElement('div'); 
        const listingEl = document.getElementById('feature-listing');
        // Clear any existing listings
        listingEl.innerHTML = '';
        if (features.length) {
          for (const feature of features) {
            const itemLink = document.createElement('div');
            const label =feature.properties.Country+"-"+feature.properties.ProvName;
            itemLink.textContent = label;
            itemLink.addEventListener('mouseover', () => {
                console.log(feature.geometry.coordinates[0][0]);
                setFirstReligion(feature.properties.HighRelig);
                setSecondReligion(feature.properties.SecRelig);
                setProvince(feature.properties.ProvName);
                setCountry(feature.properties.Country);
                setNumerical(feature.properties.Numerical);
                setYear(feature.properties.Year);
                setDataSource(feature.properties.DataSource);
                map.current.setFilter("hover-fills", [
                    "all",
                    ["==", "Country", feature.properties.Country],
                    ["==", "ProvName", feature.properties.ProvName],
                  ]);
                
            });
            itemLink.addEventListener('mouseleave', () => {
                map.current.setFilter("hover-fills", false);
            });
            itemLink.addEventListener('click', () => {
                map.current.flyTo({center:feature.geometry.coordinates[0][0]});
                map.current.setFilter("hover-fills", [
                    "all",
                    ["==", "Country", feature.properties.Country],
                    ["==", "ProvName", feature.properties.ProvName],
                  ]);
            });
            listingEl.appendChild(itemLink);
          }
      
        } else if (features.length === 0) {
          empty.textContent = 'No results found';
          listingEl.appendChild(empty);
        } else {
          empty.textContent = 'Drag the map to populate results';
          listingEl.appendChild(empty);
      
          // remove features filter
          map.current.setFilter("world_religion", [
            "any",
            ["==", "HighRelig", "Buddhists(Tibetan Buddhism)"],
            ["==", "HighRelig", "Buddhists(Theravada)"],
            ["==", "HighRelig", "Buddhists(Mahayana)"],
          ]);
        }
      }
      


    return (
        <div className="map">
            <div className="container">
                <div
                    className="container"
                    style={{ flexDirection: "row", alignItems: "center" }}
                >
                    <div className="religionIcon buddhismIcon"></div>
                    <h1 className="introTitle">BUDDHISM</h1>
                </div>
                <div className="introContent">
                    <p>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsum dolor
                    quo labore numquam repellendus iusto omnis incidunt, aliquid provident
                    sunt repellat cum nihil adipisci doloremque saepe tenetur commodi,
                    recusandae velit.
                    </p>
                </div>
            </div>
        
            <div>
                {display==="map"&&(
                    <div className="displayButtons">
                        <button style={{backgroundColor:"grey"}} onClick={()=>{setDisplay("map");window.location.reload();}}>Mapping</button>
                        <button onClick={()=>setDisplay("chart")}>Chart Data</button>
                    </div>
                )}

                {display==="chart"&&(
                    <div className="displayButtons">
                        <button onClick={()=>{setDisplay("map");window.location.reload();}}>Mapping</button>
                        <button style={{backgroundColor:"grey"}} onClick={()=>setDisplay("chart")}>Chart Data</button>
                    </div>
                )}

                {display==="map" &&
                    <>
                        <div className="label" style={{display:"flex"}}>
                            <div>- 90</div>
                            <div>- 70</div>
                            <div>- 50</div>
                            <div>- 30</div>
                        </div>
                        {buddhismSubs.map((e) => <Legend sub={e} map={map}/>)}
                        <div ref={mapContainer} className="map-container" />
                        <div id="feature-listing"></div>
                        <div className="infoDisplay">
                            <div><h3>Country:</h3> {country} </div>
                            <div><h3>Province:</h3> {province} </div>
                            <div><h3>First Religion:</h3> {firstReligion} {numerical}%</div>
                            <div><h3>Second Religion:</h3> {secondReligion||"..."}</div>
                            <div><h3>Year:</h3> {year}</div>
                            <div><h3>Data Source:</h3> {dataSource}</div>
                        </div>
                    </>
                    
                }
                {display==="chart" &&<Chart religion="Buddhists(Tibetan Buddhism)"/>}
            </div>

        </div>
    );
};

export default Buddhism;